import { z } from "zod";

export const ChangeFileTaxonomyInputSchema = z.object({
    fileId: z.string(),
    requestId: z.string(),
    taxonomyId: z.number().nullish(),
    userName: z.string().nullish(),
});

export type ChangeFileTaxonomyInput = z.infer<typeof ChangeFileTaxonomyInputSchema>;